export default "__VITE_ASSET__93yjUxeu__"